import { useTheme } from "@emotion/react";
import { Hub } from "@mui/icons-material";
import { Avatar, Box, Typography } from "@mui/material";
import React from "react";




export const System = ({msg}) =>{
  const theme = useTheme();

    return (
        <Box sx={{marginTop:2, textAlign:'left'}} display="flex" alignItems="flex-start">
        <Avatar sx={{  backgroundColor: theme.palette.primary.main, marginRight: 1, marginTop:0 }}>
          <Hub />
        </Avatar>
          <div dangerouslySetInnerHTML={{__html:msg}}/>
      </Box>

    )
}